import { PATHWAY } from "@/constants/testIds";
import {
  EXCEPTION_LOOP,
  GOVERNANCE_STATE_DEFAULT,
  OPERATIONAL_CONFIDENCE,
} from "@/lib/pathwayData";

const toneStyle = {
  ok: { mark: "✓", text: "text-amber-500", border: "border-amber-700/50" },
  warn: { mark: "⚠", text: "text-[#dc2626]", border: "border-[#7F1D1D]/60" },
  muted: { mark: "○", text: "text-neutral-300", border: "border-white/15" },
  katlas: {
    mark: "▣",
    text: "text-amber-500",
    border: "border-amber-700",
  },
};

export function GovernanceStateCard({ state = GOVERNANCE_STATE_DEFAULT, sticky }) {
  return (
    <aside
      data-testid={PATHWAY.governanceState}
      className={`border hairline bg-[#0f0f0f] ${
        sticky ? "md:sticky md:top-24" : ""
      }`}
    >
      <div className="border-b hairline px-5 py-3 font-mono text-[10px] uppercase tracking-[0.28em] text-amber-500">
        Governance state
      </div>
      <ul>
        {state.map((s) => {
          const t = toneStyle[s.tone] || toneStyle.muted;
          return (
            <li
              key={s.slug}
              data-testid={PATHWAY.governanceFacet(s.slug)}
              className="grid grid-cols-[36px_1fr_auto] items-center gap-3 border-b hairline px-5 py-3"
            >
              <span className={`font-mono text-base ${t.text}`}>{t.mark}</span>
              <span className="text-[13px] text-neutral-200">{s.label}</span>
              <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-neutral-400">
                {s.value}
              </span>
            </li>
          );
        })}
      </ul>
      <div className="px-5 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
        Illustrative · synthetic state
      </div>
    </aside>
  );
}

export function ExceptionLoop() {
  return (
    <div
      data-testid={PATHWAY.exceptionLoop}
      className="border hairline bg-[#0a0a0a]"
    >
      <div className="border-b hairline px-5 py-3 font-mono text-[10px] uppercase tracking-[0.28em] text-amber-500">
        Exception loop · how a conflict is governed
      </div>
      <ol className="flex flex-col md:flex-row md:flex-wrap">
        {EXCEPTION_LOOP.map((step, i) => {
          const t = toneStyle[step.tone] || toneStyle.muted;
          return (
            <li
              key={step.n}
              data-testid={PATHWAY.exceptionLoopStep(i + 1)}
              className="flex flex-1 items-center gap-3 border-b border-r hairline px-4 py-3 last:border-r-0 md:basis-1/3"
            >
              <span
                className={`flex h-7 w-7 items-center justify-center border ${t.border} font-mono text-xs ${t.text}`}
              >
                {t.mark}
              </span>
              <div>
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-neutral-500">
                  {step.n}
                </div>
                <div className="font-serif text-[15px] leading-tight text-neutral-100">
                  {step.label}
                </div>
              </div>
            </li>
          );
        })}
      </ol>
      <div className="px-5 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
        AI alone goes straight from recommendation to decision. KATLAS routes
        conflicts through the governance node and a human reviewer.
      </div>
    </div>
  );
}


export function ConfidenceCard({ items = OPERATIONAL_CONFIDENCE }) {
  return (
    <aside
      data-testid={PATHWAY.confidenceCard}
      className="border hairline bg-[#0f0f0f]"
    >
      <div className="border-b hairline px-5 py-3 font-mono text-[10px] uppercase tracking-[0.28em] text-amber-500">
        Operational confidence
      </div>
      <ul>
        {items.map((c) => {
          const t = toneStyle[c.tone] || toneStyle.muted;
          return (
            <li
              key={c.slug}
              data-testid={PATHWAY.confidenceItem(c.slug)}
              className="grid grid-cols-[1fr_auto] items-baseline gap-3 border-b hairline px-5 py-3"
            >
              <span className="text-[13px] text-neutral-200">{c.label}</span>
              <span
                className={`font-mono text-[12px] tracking-[0.06em] ${t.text}`}
              >
                {c.value}
              </span>
            </li>
          );
        })}
      </ul>
      <div className="px-5 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
        Operational, not AI. How confident is the operation as a whole.
      </div>
    </aside>
  );
}
